<template>
	<div v-if="bookNotFound" class="center-container">
		<h1>Book not found</h1>
		<p>Sorry, but there is no book with that ID in our database. If this problem persists, contact <a href="mailto:support@bookplate.co">support@bookplate.co</a>.</p>
		<h2><router-link to='/'>Return Home</router-link></h2>
	</div>
	<section v-else class="book-grid">
		<section class="book-cover">
			<a class="loading cover large" v-if="coverImage == '' || coverImage == 'undefined' || coverImage == null"></a>
			<a v-else class="cover large" v-bind:href="coverImage" target="_blank" v-bind:style="{ backgroundImage: 'url(' + coverImage + ')', backgroundColor: coverColor }">"{{ bookTitle }}" book cover</a>
			
			<div class="cover-buttons">
				<button data-tooltip="Mark as read" id="read-btn" v-on:click="addToList('read')" class="eye icon" :class="readState">{{ readState == "selected" ? 'Unmark as Read' : 'Mark as read'}}</button>
				<button data-tooltip="Like book" id="liked-btn" v-on:click="addToList('liked')" class="heart icon" :class="likedState">{{ likedState == "selected" ? 'Unlike book' : 'Like book'}}</button>
			</div>
		</section>
		<article class="book-content">
			<div class="loading h1" v-if="bookTitle == '' || bookTitle == 'undefined' || bookTitle == null">Loading</div>
			<h1 v-else>{{ bookTitle }}</h1>

			<div class="loading h2" v-if="authors == '' || authors == 'undefined' || authors == null">Loading</div>
			<h2 v-else>
				<template v-for="author in authors"><router-link :key="author.name" :to="{path:'/author/' + author.author_id}">{{ author.name }}</router-link>, </template>{{ year }}
			</h2>

			<div class="loading p" v-if="description == '' || description == 'undefined' || description == null">Loading<span></span><span></span></div>
			<p v-else>{{description}}</p>

			<div class="content-buttons">
				<button id="to-read-btn" v-on:click="addToList('to_read')" :class="toReadState">{{ toReadState == "selected" ? 'Take Off To-Read' : 'Add To-Read List' }}</button>
				<button id="library-btn" v-on:click="addToList('library')" :class="libraryState">{{ libraryState == "selected" ? 'Remove From Library' : 'Add To My Library'}}</button>
			</div>
			<div class="community-library">
				<h6>
					<span :style="{ marginRight: '1rem' }" v-if="pageCount == '' || pageCount == 'undefined' || pageCount == null">### p.</span>
					<span :style="{ marginRight: '1rem' }" v-else >{{ pageCount }} p.</span>
					<span :style="{ marginRight: '1rem', float: 'right' }">In the library of:</span>
				</h6>
				<p v-if="friends == ''">No one you know.</p>
				<router-link v-else v-for="friend in friends" :key="friend.name" :to="{path:'/profile/' + friend.id}" v-bind:style="{ background: friend.profile_color }" class="profile">{{ friend.name }}</router-link>
			</div>
		</article>
	</section>
</template>
<script>
export default
{
	data () 
	{
		return {
			info: "",
			readerData: {
				readBtn: "disabled",
				likedBtn: "disabled",
				toReadBtn: "disabled",
				libraryBtn: "disabled",
				friendsLib: ""
			},
			notFound: false
		}
	},
	mounted () 
	{
		try 
		{
			let vue = this;

			fetch('https://api.bookplate.co/book/' + this.bookId,
			{
				credentials: 'include'
			})
			.then(function(response)
			{
				if(response.status == 404)
				{
					vue.notFound = true;
					return "";
				}

				return response.json();
			})
			.then(json => this.info = json)
			.then(function (json) 
			{
				if(vue.notFound)
				{
					document.title = "Book not found | Bookplate";
				}
				else
				{
					document.title = json.title + " | Bookplate";
				}
			})

			if(!vue.notFound && vue.$store.getters.userId != "0")
			{
				fetch('https://api.bookplate.co/reader/book/' + this.bookId,
				{
					credentials: 'include'
				})
				.then(function(response)
				{
					if(response.status == 404)
					{
						return "";
					}
					else if(response.status == 401)
					{
						console.log("You must be logged in. (Try refreshing the page)");
						vue.$store.dispatch('saveUserLogged', "0");
						vue.router.replace("/book/" + vue.$route.params.id + "?=logout");
						return "";
					}
					else if(response.status != 200)
					{
						vue.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co.", "Error loading your data (" + response.status + ")");
						return "";
					}

					return response.json();
				})
				.then(function (json) 
				{
					vue.readerData.readBtn = ((json.read) ? "selected" : "");
					vue.readerData.likedBtn = ((json.liked) ? "selected" : "");
					vue.readerData.toReadBtn = ((json.to_read) ? "selected" : "");
					vue.readerData.libraryBtn = ((json.library) ? "selected" : "");
					vue.readerData.friendsLib = json.friends;
				})
			}
			else
			{
				vue.readerData.readBtn = "";
				vue.readerData.likedBtn = "";
				vue.readerData.toReadBtn = "";
				vue.readerData.libraryBtn = "";
			}
		}
		catch(e)
		{
			this.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co. Error:" + e, "An error occured");
		}
	},
	computed: 
	{
		bookNotFound: function()
		{
			return this.notFound;
		},
		bookId: function() 
		{
			return this.$route.params.id;
		},
		bookTitle: function()
		{
			return this.info.title;
		},
		authors: function()
		{
			return this.info.authors;
		},
		year: function()
		{
			return this.info.year;
		},
		coverImage: function()
		{
			return this.info.cover_url;
		},
		coverColor: function()
		{
			return this.info.book_color;
		},
		description: function()
		{
			return this.info.description;
		},
		pageCount: function()
		{
			return this.info.page_count;
		},
		readState: function()
		{
			return this.readerData.readBtn;
		},
		likedState: function()
		{
			return this.readerData.likedBtn;
		},
		toReadState: function()
		{
			return this.readerData.toReadBtn;
		},
		libraryState: function()
		{
			return this.readerData.libraryBtn;
		},
		friends: function()
		{
			return this.readerData.friendsLib;
		}
	},
	created () 
	{
		document.title = "Bookplate";
	},
	methods: 
	{
		addToList: function(list) 
		{
			try
			{
				window.navigator.vibrate(30);
			}
			catch(e)
			{
				//pass
			}

			if(this.$store.getters.userId == "0")
			{
				this.$alert("You must be logged in. Try refreshing the page or contact support@bookplate.co if the problem persists.", "Not logged in");
				return "";
			}

			const data = {
				headers: 
				{ 
					"content-type": "application/json; charset=UTF-8",
					"accept": "application/text"
				},
				body: JSON.stringify({
					"list": list,
					"book_id": this.bookId
				}),
				credentials: 'include',
				method: "POST"
			};

			let add = true;

			switch (list)
			{
				case "read":
					document.getElementById("read-btn").blur();
					if(this.readerData.readBtn == "selected")
					{
						this.readerData.readBtn = "";
						add = false;
					}
					else
					{
						this.readerData.readBtn = "selected";
						this.readerData.toReadBtn = "";
					}
					break;
				case "liked":
					document.getElementById("liked-btn").blur();
					if(this.readerData.likedBtn == "selected")
					{
						this.readerData.likedBtn = "";
						add = false;
					}
					else
					{
						this.readerData.likedBtn = "selected";

						if(this.readerData.readBtn != "selected")
						{
							this.readerData.readBtn = "selected";
							this.readerData.toReadBtn = "";
						}
					}
					break;
				case "to_read":
					document.getElementById("to-read-btn").blur();
					if(this.readerData.toReadBtn == "selected")
					{
						this.readerData.toReadBtn = "";
						add = false;
					}
					else
					{
						this.readerData.toReadBtn = "selected";
					}
					break;
				case "library":
					document.getElementById("library-btn").blur();
					if(this.readerData.libraryBtn == "selected")
					{
						this.readerData.libraryBtn = "";
						add = false;
					}
					else
					{
						this.readerData.libraryBtn = "selected";
					}
				}

			if(add)
			{
				fetch("https://api.bookplate.co/list/add", data)
				.then(res=>console.log(res))
				.catch(error=>console.log(error));
			}
			else
			{
				fetch("https://api.bookplate.co/list/remove", data)
				.then(res=>console.log(res))
				.catch(error=>console.log(error));
			}
		}
	}
}
	
</script>